import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationStore } from '@argo/navigation';
import { NavigationPhase } from '@argo/navigation';
import { CommonPhase } from '@argo/common';
import { Router } from '@angular/router';
import { 
  ScaModuleTitleComponent,
  ScaCardWorkshopComponent,
  ScaAlertComponent,
  ScaBadgeComponent,
  ScaIconComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-navigation-test-complete',
  standalone: true,
  imports: [
    CommonModule,
    ScaModuleTitleComponent,
    ScaCardWorkshopComponent,
    ScaAlertComponent,
    ScaBadgeComponent,
    ScaIconComponent
  ],
  templateUrl: './navigation-test-complete-redesigned.component.html',
  styleUrl: './navigation-test-complete-redesigned.component.scss'
})
export class NavigationTestCompleteComponent {
  readonly navStore = inject(NavigationStore);
  readonly router = inject(Router);
  readonly CommonPhase = CommonPhase;
  readonly NavigationPhase = NavigationPhase;
  readonly coverage = 100;
}

